import React, { useState } from 'react';
import { Edit2, XCircle, X, Filter } from 'lucide-react';
import { useAdmin } from '../context/AdminContext';

export default function LinesPage() {
  const {
    routes, loadingRoutes, stops, showRouteModal, setShowRouteModal,
    selectedRoute, setSelectedRoute, routeForm, setRouteForm, loadRoutesFromAPI,
  } = useAdmin();
  const [routeFilter, setRouteFilter] = useState('');

  const handleAddRoute = () => { setRouteForm({ departure_id: '', arrival_id: '', bidirectional: true, active: true }); setSelectedRoute(null); setShowRouteModal(true); };
  const handleEditRoute = (route) => {
    setRouteForm({ departure_id: route.departure?.stop_id || '', arrival_id: route.arrival?.stop_id || '', bidirectional: route.bidirectional !== false, active: route.active });
    setSelectedRoute(route.route_id); setShowRouteModal(true);
  };

  const handleSaveRoute = async () => {
    if (!routeForm.departure_id || !routeForm.arrival_id) { alert("Veuillez sélectionner un arrêt de départ et un arrêt d'arrivée"); return; }
    if (routeForm.departure_id === routeForm.arrival_id) { alert("Le départ et l'arrivée doivent être différents"); return; }
    try {
      const apiService = (await import('../apiService')).default;
      if (selectedRoute) {
        await apiService.put(`/routes/${selectedRoute}`, routeForm, { userType: 'admin' });
      } else {
        await apiService.post('/routes', routeForm, { userType: 'admin' });
      }
      setShowRouteModal(false); loadRoutesFromAPI();
    } catch (error) { alert(error.message || 'Erreur lors de la sauvegarde'); }
  };

  const handleDeleteRoute = async (routeId) => {
    if (!window.confirm('Supprimer cette ligne ?')) return;
    try {
      const apiService = (await import('../apiService')).default;
      await apiService.delete(`/routes/${routeId}`, { userType: 'admin' });
      loadRoutesFromAPI();
    } catch (error) { alert(error.message || 'Erreur'); }
  };

  const handleToggleRouteStatus = async (route) => {
    try {
      const apiService = (await import('../apiService')).default;
      await apiService.put(`/routes/${route.route_id}`, { active: !route.active }, { userType: 'admin' });
      loadRoutesFromAPI();
    } catch (error) { alert(error.message || 'Erreur'); }
  };

  const activeStops = stops.filter(s => s.active);
  const filteredRoutes = routeFilter
    ? routes.filter(r => r.departure?.stop_id === routeFilter || r.arrival?.stop_id === routeFilter)
    : routes;

  return (
    <div className="dashboard-content">
      <div className="page-header">
        <h1 className="page-title">Gestion des Lignes</h1>
        <button className="btn-primary" onClick={handleAddRoute} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>+ Nouvelle Ligne</button>
      </div>
      <p style={{ color: '#5C636E', marginBottom: '1rem', fontSize: '0.95rem' }}>
        Une ligne relie deux arrêts (départ → arrivée). Les lignes sont bidirectionnelles par défaut.
      </p>
      <div style={{ marginBottom: '1.5rem', display: 'flex', alignItems: 'center', gap: '1rem' }}>
        <Filter size={18} style={{ color: '#5C636E' }} />
        <select value={routeFilter} onChange={(e) => setRouteFilter(e.target.value)}
          style={{ padding: '0.5rem 1rem', border: '1px solid #E9EBEF', borderRadius: '6px', fontSize: '0.95rem', minWidth: '200px' }}>
          <option value="">Tous les arrêts</option>
          {activeStops.map(s => <option key={s.stop_id} value={s.stop_id}>{s.name}</option>)}
        </select>
        {routeFilter && <span style={{ color: '#5C636E', fontSize: '0.85rem' }}>{filteredRoutes.length} ligne(s) trouvée(s)</span>}
      </div>

      {showRouteModal && (
        <div className="modal-overlay" onClick={() => setShowRouteModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ width: '550px', maxWidth: '90vw' }}>
            <div className="modal-header">
              <h2>{selectedRoute ? 'Modifier la ligne' : 'Nouvelle ligne'}</h2>
              <button className="close-btn" onClick={() => setShowRouteModal(false)}><X size={24} /></button>
            </div>
            <div className="modal-body" style={{ padding: '2rem' }}>
              <div style={{ marginBottom: '1.5rem' }}>
                <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600', color: '#1E2229' }}>Arrêt de départ *</label>
                <select value={routeForm.departure_id} onChange={(e) => setRouteForm({ ...routeForm, departure_id: e.target.value })}
                  style={{ width: '100%', padding: '0.75rem', border: '1px solid #E9EBEF', borderRadius: '6px', fontSize: '1rem', boxSizing: 'border-box' }}>
                  <option value="">-- Sélectionner un arrêt --</option>
                  {activeStops.filter(s => s.stop_id !== routeForm.arrival_id).map(s => (
                    <option key={s.stop_id} value={s.stop_id}>{s.name}</option>
                  ))}
                </select>
              </div>
              <div style={{ textAlign: 'center', margin: '0.5rem 0', color: '#5C636E', fontSize: '1.5rem' }}>↕</div>
              <div style={{ marginBottom: '1.5rem' }}>
                <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600', color: '#1E2229' }}>Arrêt d'arrivée *</label>
                <select value={routeForm.arrival_id} onChange={(e) => setRouteForm({ ...routeForm, arrival_id: e.target.value })}
                  style={{ width: '100%', padding: '0.75rem', border: '1px solid #E9EBEF', borderRadius: '6px', fontSize: '1rem', boxSizing: 'border-box' }}>
                  <option value="">-- Sélectionner un arrêt --</option>
                  {activeStops.filter(s => s.stop_id !== routeForm.departure_id).map(s => (
                    <option key={s.stop_id} value={s.stop_id}>{s.name}</option>
                  ))}
                </select>
              </div>
              {routeForm.departure_id && routeForm.arrival_id && (
                <div style={{ background: '#FEE9E2', border: '1px solid #bae6fd', borderRadius: '8px', padding: '1rem', marginBottom: '1.5rem', textAlign: 'center' }}>
                  <span style={{ fontWeight: '600', color: '#C9350F' }}>
                    {activeStops.find(s => s.stop_id === routeForm.departure_id)?.name} → {activeStops.find(s => s.stop_id === routeForm.arrival_id)?.name}
                  </span>
                  {routeForm.bidirectional && <span style={{ color: '#5C636E', display: 'block', fontSize: '0.85rem', marginTop: '0.25rem' }}>↔ Bidirectionnelle (les deux sens)</span>}
                </div>
              )}
              <div style={{ marginBottom: '1.5rem' }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', cursor: 'pointer', fontWeight: '600', color: '#1E2229' }}>
                  <input type="checkbox" checked={routeForm.bidirectional} onChange={(e) => setRouteForm({ ...routeForm, bidirectional: e.target.checked })} style={{ width: '18px', height: '18px', cursor: 'pointer' }} />
                  Bidirectionnelle (fonctionne dans les deux sens)
                </label>
              </div>
              <div style={{ marginBottom: '2rem' }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', cursor: 'pointer', fontWeight: '600', color: '#1E2229' }}>
                  <input type="checkbox" checked={routeForm.active} onChange={(e) => setRouteForm({ ...routeForm, active: e.target.checked })} style={{ width: '18px', height: '18px', cursor: 'pointer' }} />
                  Ligne active
                </label>
              </div>
              <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'flex-end' }}>
                <button className="btn-secondary" onClick={() => setShowRouteModal(false)} style={{ padding: '0.75rem 1.5rem' }}>Annuler</button>
                <button className="btn-primary" onClick={handleSaveRoute} style={{ padding: '0.75rem 1.5rem' }}>{selectedRoute ? 'Modifier' : 'Créer'}</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {loadingRoutes ? (
        <div style={{ textAlign: 'center', padding: '3rem', color: '#5C636E' }}>Chargement...</div>
      ) : filteredRoutes.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '3rem', color: '#5C636E' }}>
          <p style={{ fontSize: '1.1rem' }}>{routeFilter ? 'Aucune ligne pour cet arrêt' : 'Aucune ligne définie'}</p>
          {!routeFilter && <button className="btn-primary" onClick={handleAddRoute} style={{ marginTop: '1rem' }}>+ Créer une première ligne</button>}
        </div>
      ) : (
        <div className="table-container">
          <table className="data-table">
            <thead>
              <tr><th>Départ</th><th>Arrivée</th><th>Direction</th><th>Chauffeurs</th><th>Statut</th><th>Actions</th></tr>
            </thead>
            <tbody>
              {filteredRoutes.map(route => (
                <tr key={route.route_id}>
                  <td style={{ fontWeight: '600' }}>{route.departure?.name || '?'}</td>
                  <td style={{ fontWeight: '600' }}>{route.arrival?.name || '?'}</td>
                  <td><span style={{ fontSize: '0.85rem', color: '#5C636E' }}>{route.bidirectional !== false ? '↔ Deux sens' : '→ Un sens'}</span></td>
                  <td>{route.drivers_count || 0} chauffeur{(route.drivers_count || 0) > 1 ? 's' : ''}</td>
                  <td>
                    <span style={{ padding: '0.35rem 0.75rem', borderRadius: '20px', fontSize: '0.75rem', fontWeight: '600', background: route.active ? '#ECFDF5' : '#fee2e2', color: route.active ? '#166534' : '#991b1b', textTransform: 'uppercase', cursor: 'pointer' }}
                      onClick={() => handleToggleRouteStatus(route)}>
                      {route.active ? '✅ Active' : '❌ Inactive'}
                    </span>
                  </td>
                  <td style={{ display: 'flex', gap: '0.5rem' }}>
                    <button className="icon-btn" onClick={() => handleEditRoute(route)} title="Modifier" style={{ padding: '0.5rem', color: '#FF7800' }}><Edit2 size={18} /></button>
                    <button className="icon-btn" onClick={() => handleDeleteRoute(route.route_id)} title="Supprimer" style={{ padding: '0.5rem', color: '#DC2626' }}><XCircle size={18} /></button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
